// import React from "react";
// import { Form, Typography, Divider, Space } from "antd";
// import {MailOutlined,LockOutlined,RightOutlined} from "@ant-design/icons";

// import FormInput from "../FormInput";
// import ButtonComponent from "../Button/Button";
// import HeaderComponentWithTitleAndLogo from "../HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
// import MainLayout from "../MainLayout/MainLayout";
// import "./Login.scss";

// const { Link } = Typography;

// const Login = ({ ...props }) => {
//     const onFinish = (values) => {
//         console.log("Login values:", values);
//         props.onFinishHandle(values);
//     };

//     return (
//         <MainLayout>
//             <div className="login-card-new">
//                 {/* Logo */}
//                 <HeaderComponentWithTitleAndLogo
//                     logoSrc="/websiteLogo.png"
//                     logoAlt="Leveridge Logo"
//                     title={props.title}
//                     // subtitle={props.title}
//                 />
//                 <Form
//                     layout="vertical"
//                     className="login-form-new"
//                     onFinish={onFinish}
//                 >
//                     <FormInput
//                         label="Email Address"
//                         name="email"  display: flex;

//                         placeholder="Email Address"
//                         prefix={<MailOutlined />}
//                         rules={[
//                             { required: true, message: "Email is required" },
//                             { type: "email", message: "Enter a valid email" },
//                         ]}
//                     />

//                     <FormInput
//                         label="Password"  display: flex;

//                         name="password"
//                         type="password"
//                         placeholder="Password"
//                         prefix={<LockOutlined />}
//                         rules={[
//                             { required: true, message: "Password is required" },
//                         ]}
//                     />

//                     <Form.Item className="forgot">
//                         <Link onClick={props.forgotPassword}>Forgot password ?</Link>
//                     </Form.Item>
//                     {/* Login Button */}
//                     <Form.Item>
//                         <ButtonComponent
//                             text="Login"
//                             htmlType="submit"
//                             className="login-card-new__button"
//                         />
//                     </Form.Item>
//                     {props.isNewAccountCreateFlag &&
//                         <Form.Item className="forgot create-account-text">
//                             <Link onClick={props.createNewAccount}>Create an account</Link>
//                         </Form.Item>}
//                 </Form>

//                 <Divider>OR</Divider>

//                 {/* Role Links */}
//                 <Space direction="vertical" className="roles">
//                     {props.role !== "investor" && <Link onClick={props.consumerLogin}>Investor <RightOutlined /></Link>}
//                     {props.role !== "administrator" && <Link onClick={props.administratorLogin}>Administrator <RightOutlined /> </Link>}
//                     {props.role !== "capitalProvider" && <Link onClick={props.capitalProviderLogin}>Capital Provider <RightOutlined /> </Link>}
//                 </Space>

//             </div>
//         </MainLayout>
//     );
// };

// export default Login;


import React, { useState,useEffect } from "react";
import { Form, Typography, Divider, Checkbox,Select } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";

import FormInput from "../FormInput";
import ButtonComponent from "../Button/Button";
import MainLayout from "../MainLayout/MainLayout";
import "./Login.scss";

const { Link, Title, Text } = Typography;

const Login = ({ ...props }) => {
    const [role, setRole] = useState("Investor");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const onFinish = (values) => {
        props.onFinishHandle({ ...values, role });
    };

    return (
        <MainLayout>
            <div className="login-page">
                <div className="login-card">
                    <Title level={1} >Platform Access</Title>
                    <p className="subtitle">
                        Sign in to access institutional infrastructure for private credit
                    </p>

                    <div class="ant-col ant-form-item-label userTypeLable"><label>User Type</label></div>

                    {isMobile ? (
                        <Select
                            value={props.role}
                            onChange={(value) => {
                                if (value === "investor") props.consumerLogin();
                                if (value === "capitalProvider") props.capitalProviderLogin();
                                if (value === "administrator") props.administratorLogin();
                            }}
                            className="role-select"
                            options={[
                                { label: "Investor", value: "investor" },
                                { label: "Capital Provider", value: "capitalProvider" },
                                { label: "Administrator", value: "administrator" },
                            ]}
                        />
                    ) : (
                        <div className="role-tabs">
                            {[
                                { label: "Investor", value: "investor", onClick: props.consumerLogin },
                                { label: "Capital Provider", value: "capitalProvider", onClick: props.capitalProviderLogin },
                                { label: "Administrator", value: "administrator", onClick: props.administratorLogin },
                            ].map((item) => (
                                <button
                                    key={item.value}
                                    className={props.role === item.value ? "active" : ""}
                                    onClick={item.onClick}
                                    type="button"
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    )}

                    <Form layout="vertical" onFinish={onFinish}>
                        <FormInput
                            label="Email Address"
                            name="email"
                            placeholder="Enter Email"
                            prefix={<MailOutlined />}
                            rules={[
                                { required: true, message: "Email is required" },
                                { type: "email", message: "Enter a valid email" },
                            ]}
                        />

                        <FormInput
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            prefix={<LockOutlined />}
                            rules={[
                                { required: true, message: "Password is required" },
                            ]}
                        />

                        <div className="remember-row">
                            <Checkbox defaultChecked>Remember me</Checkbox>
                            <Link className="forgotPasswordLink" onClick={props.forgotPassword}>Forgot password?</Link>
                        </div>

                        <ButtonComponent
                            text="Sign In"
                            htmlType="submit"
                            className="primary-btn f16"
                        />
                    </Form>

                    <Divider className="loginOrDivider">or</Divider>

                    {props.isNewAccountCreateFlag &&
                        <ButtonComponent
                            text="Request Access"
                            className="secondary-btn f16"
                            type="default"
                            onClick={props.createNewAccount}
                        />}

                    <p className="contact-text">
                        Don’t have access? <a style={{color:"#fff"}} target="_blank" href="https://levridge.ai/contact">Contact our team</a>
                    </p>
                </div>
            </div>
        </MainLayout>
    );
};

export default Login;
